<template>
  <div class="info-box" :class="getBackgroundClass">
    <div class="row">
      <div class="col-12 col-md-2 d-print-none">
        <div class="info-box__icon">
          <iconWarning class="icon" v-if="type === 'warning' || type === 'information'"></iconWarning>
          <iconDanger class="icon" v-else-if="type === 'danger'"></iconDanger>
        </div>
      </div>
      <div class="col-12 col-md-10">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import iconWarning from '@/assets/icons/warning-orange.svg'
import iconDanger from '@/assets/icons/danger-red.svg'

export default {
  name: 'CiInfoBox',
  components: {
    iconWarning,
    iconDanger,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    getBackgroundClass() {
      return {
        warning: this.type === 'warning',
        danger: this.type === 'danger',
        info: this.type === 'information',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.info-box {
  border-radius: 4px;
  border: 1px solid rgba(155, 155, 155, 0.5);
  box-shadow: 0 2px 23px 0 #ededed;
  margin: 20px 0;
  overflow: hidden;
  padding: 20px;
  position: relative;

  @include media-breakpoint-up(md) {
    padding: 35px;
  }

  &.warning {
    border: 1px solid #f8e71c;
    background-color: rgba(248, 231, 28, 0.15);
  }

  &.danger {
    border: 1px solid #ff4d4f;
    background-color: rgba(255, 77, 79, 0.1);
  }

  &.information {
    border: 1px solid #90a4ae;
    background-color:  rgba(144, 164, 174, 0.1);
  }
}

.info-box__icon {
  align-items: center;
  display: flex;
  justify-content: center;
}

.icon {
  width: 60px;
  height: auto;
  margin: 0 0 20px 0;

  @include media-breakpoint-up(md) {
    margin: 5px 0 0 0;
  }
}
</style>
